import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../base/dtos/base-search.dto';
import { FileDto } from '../../files/dtos/file.dto';

/**
 * Vehicle make DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleMakeSearchDto extends BaseSearchDto {
	name!: string;
	externalReference?: string;
	files?: FileDto[];

	displayValue(): string | null {
		return `${this.name}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return null;
	}
}
